import { ILogFields, TLogFieldValues } from './interfaces';
import { Either } from 'tsmonad';
import { identity } from 'ramda';
import { captureError } from '@/services/TrackerService/Sentry';
import { hasValueDeep, mapObjDeep } from '@/utils';

type SanitizerError = {
  raw: ILogFields;
  message: string;
  sanitized: ILogFields;
};

const isNaNValue = (v: TLogFieldValues): boolean => typeof v === 'number' && isNaN(v);
const hasNaNValueDeep = hasValueDeep(isNaNValue);

export const sanitizeNaN = (log: ILogFields): Either<SanitizerError, ILogFields> => {
  const DEFAULT_VAL = 0;
  const sanitize = mapObjDeep((v) => (isNaNValue(v) ? DEFAULT_VAL : v));

  return hasNaNValueDeep(Object.values(log))
    ? Either.left<SanitizerError, ILogFields>({
        raw: log,
        message: '[Kinesis.put] NaN 값은 허용되지 않습니다.',
        sanitized: sanitize(log),
      })
    : Either.right<SanitizerError, ILogFields>(log);
};

export const sanitizeWithReport = (log: ILogFields): ILogFields =>
  Either.right(log)
    .bind(sanitizeNaN)
    .caseOf({
      left: ({ raw, message, sanitized }: SanitizerError) => {
        captureError(raw, message);
        return sanitized;
      },
      right: identity,
    });
